import { useCallback, useEffect, useRef } from 'react'

export const useGracePeriodTimeout = () => {
  const timeoutRef = useRef(null)

  const clearGracePeriodTimeout = useCallback(() => {
    if (!timeoutRef.current) return

    clearTimeout(timeoutRef.current)
    timeoutRef.current = null
  }, [])

  const scheduleGracePeriodTimeout = useCallback(
    (callback, delay) => {
      clearGracePeriodTimeout()
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = null
        callback()
      }, delay)
    },
    [clearGracePeriodTimeout]
  )

  useEffect(() => clearGracePeriodTimeout, [clearGracePeriodTimeout])

  return {
    clearGracePeriodTimeout,
    scheduleGracePeriodTimeout,
  }
}
